import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import { useAppDispatch, useAppSelector } from '@shared/hooks';
import type { PlatformSettings } from '@shared/types/common';

const initialState: { settings: PlatformSettings } = {
  settings: {
    iframe_url: '',
    support_phone: '',
    moderation: true,
    allow_coach_register: false,
    grecaptcha_enabled: false,
    grecaptcha_public_key: '',
    is_call_active: false,
    is_sms_active: false,
    has_library: false,
    first_method: 'CALL',
  },
};

const platformSettingsSlice = createSlice({
  name: 'common/platformSettings',
  initialState: initialState,
  reducers: {
    setPlatformSettings: (state, action: PayloadAction<PlatformSettings>) => {
      state.settings = action.payload;
    },
  },
});

export const platformSettingsReducer = platformSettingsSlice.reducer;
const actions = platformSettingsSlice.actions;

const selectPlatformSettings = (state: RootState) => state.common.platformSettings.settings;

export const usePlatformSettingsModel = () => {
  const dispatch = useAppDispatch();
  const setSettings = (settings: PlatformSettings) =>
    dispatch(actions.setPlatformSettings(settings));

  const platformSettings = useAppSelector(selectPlatformSettings);
  return {
    setSettings,
    platformSettings,
  };
};
